var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"superadmin-operator-menu"},_vm._l((_vm.menu),function(item,index){return _c(_vm.resolveNavHeaderComponent(item),{key:item.title,tag:"component",attrs:{"isLastItem":index === _vm.menu.length - 1,"item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }